export default __webpack_public_path__ + "static/media/error-warning-fill.71c3a547.svg";